export const FEATURE_FLAG_QUERY_KEY = 'toolkitFeatureFlags';
export const FEATURE_FLAG_STALE_TIME = 1000 * 60 * 5; // 5 minutes
export const FEATURE_FLAG_RETRY = 2;
export const FEATURE_FLAG_RETRY_DELAY = 2000;
export const FEATURE_FLAG_TIMEOUT = 5000;
export const FEATURE_FLAG_FALLBACK_NAMESPACE = 'FRONTEND';
